import { styled, Fab as FabMui } from '@mui/material';

interface IKind {
  basic: string;
  positive: string;
  negative: string;
  active: string;
  dark: string;
  'negative-outlined': string;
}

export type KindKeys = keyof IKind;

const kindStyles = (theme: any, kind: KindKeys, active: boolean) => {
  const { button } = theme.status;

  switch (kind) {
    case 'positive':
      return {
        backgroundColor: button.positive[active ? 'active' : 'default'],
        '&:hover': { backgroundColor: button.positive.hover },
        '&:pressed': { backgroundColor: button.positive.pressed },
        '&:active': { backgroundColor: button.positive.active },
        '&:disabled': { backgroundColor: button.positive.disabled },
      };
    case 'negative':
      return {
        backgroundColor: button.negative[active ? 'active' : 'default'],
        '&:hover': { backgroundColor: button.negative.hover },
        '&:pressed': { backgroundColor: button.negative.pressed },
        '&:active': { backgroundColor: button.negative.active },
        '&:disabled': { backgroundColor: button.negative.disabled },
      };
    case 'negative-outlined':
      return {
        backgroundColor: theme.palette.common.white,
        border: `2px solid ${button.negative.default}`,
        color: `${button.negative.default} !important`,
        '&:hover': {
          backgroundColor: theme.palette.common.white,
          borderColor: button.negative.hover,
        },
        '&:pressed': {
          backgroundColor: theme.palette.common.white,
          borderColor: button.negative.pressed,
        },
        '&:active': {
          backgroundColor: theme.palette.common.white,
          borderColor: button.negative.active,
        },
        '&:disabled': {
          backgroundColor: theme.palette.common.white,
          borderColor: button.negative.disabled,
        },
      };
    case 'active':
      return {
        backgroundColor: button.active.default,
        boxShadow: 'none',
        '&:hover': { backgroundColor: button.active.hover },
        '&:pressed': { backgroundColor: button.active.pressed },
        '&:active': { backgroundColor: button.active.active },
        '&:disabled': { backgroundColor: button.active.disabled },
      };
    case 'dark':
      return {
        backgroundColor: button.dark.default,
        boxShadow: 'none',
        '&:hover': { backgroundColor: button.dark.hover },
        '&:pressed': { backgroundColor: button.dark.pressed },
        '&:active': { backgroundColor: button.dark.active },
        '&:disabled': { backgroundColor: button.dark.disabled },
      };
    case 'basic':
    default:
      return {
        backgroundColor: button.basic[active ? 'active' : 'default'],
        '&:hover': { backgroundColor: button.basic.hover },
        '&:pressed': { backgroundColor: button.basic.pressed },
        '&:active': { backgroundColor: button.basic.active },
        '&:disabled': { backgroundColor: button.basic.disabled },
      };
  }
};

export const Fab = styled(FabMui)<{
  kind?: KindKeys;
  active?: boolean;
  withMargin?: boolean;
}>(({ theme, kind = 'basic', active = false, withMargin = false }) => ({
  zIndex: 'auto',
  padding: '0 10px',
  color: theme.palette.common.white,
  ...(withMargin && { marginRight: '10px' }),
  '& svg': {
    marginRight: 10,
  },
  ...kindStyles(theme, kind, active),
}));
